export var colors = {
    primaryBrighter: '#cb5aff',
    primaryBright: '#a839f3',
    primaryDeep: '#8223d2',
    primaryDeeper: '#6700b8',
    secondaryBrighter: '#6b8bff',
    secondaryBright: '#4a68f9',
    secondaryDeep: '#2743cc',
    secondaryDeeper: '#253baa',
    brandGreenBrighter: '#6efac3',
    brandGreenBright: '#00e7a1',
    brandGreenDeep: '#00b574',
    brandGreenDeeper: '#0b8350',
    brandTennis: '#d2fa46',
    white: '#ffffff',
    black: '#000000',
    neutralBrightest: '#f0f0f5',
    neutralBrighter: '#e6e6eb',
    neutralBright: '#d5d6da',
    neutralDeep: '#a5aaaf',
    neutralDeeper: '#6e767d',
    neutralDeepest: '#333f48',
    disabledBackground: '#e6e6eb',
    disabledText: '#a5aaaf',
    errorBright: '#ff5070',
    //error-lighter-1
    errorDeep: '#db1b1b',
    //error
    warningBright: '#f9d51c',
    //warning-lighter-1
    warningDeep: '#edb800',
    //warning
    successBright: '#37e7a7',
    //success-lighter-1
    successDeep: '#00bf63',
    successDeeper: '#008662'
};
